import { CountryCodes } from '../enums/countries-codes.enum';

export const COUNTRY_NAME_TO_CODE_MAP: Record<string, string> = {
  Austria: CountryCodes.AUSTRIA,
  Belgium: CountryCodes.BELGIUM,
  Bulgaria: CountryCodes.BULGARIA,
  Croatia: CountryCodes.CROATIA,
  Cyprus: CountryCodes.CYPRUS,
  'Czech Republic': CountryCodes.CZECH_REPUBLIC,
  Denmark: CountryCodes.DENMARK,
  Estonia: CountryCodes.ESTONIA,
  Finland: CountryCodes.FINLAND,
  France: CountryCodes.FRANCE,
  Germany: CountryCodes.GERMANY,
  Greece: CountryCodes.GREECE,
  Hungary: CountryCodes.HUNGARY,
  Ireland: CountryCodes.IRELAND,
  Italy: CountryCodes.ITALY,
  Latvia: CountryCodes.LATVIA,
  Lithuania: CountryCodes.LITHUANIA,
  Luxembourg: CountryCodes.LUXEMBOURG,
  Malta: CountryCodes.MALTA,
  Netherlands: CountryCodes.NETHERLANDS,
  Poland: CountryCodes.POLAND,
  Portugal: CountryCodes.PORTUGAL,
  Romania: CountryCodes.ROMANIA,
  Slovakia: CountryCodes.SLOVAKIA,
  Slovenia: CountryCodes.SLOVENIA,
  Spain: CountryCodes.SPAIN,
  Sweden: CountryCodes.SWEDEN,
};
